import React, { useCallback, useMemo } from 'react';
import { View } from 'react-native';
import BookListHor from '../components/BookListHor';
import BookListHorHeader from '../components/BookListHorHeader';
import { useShelfBooks } from '../hooks';

const tBase = 'screens.shelves';

export default function UserShelves({ navigation, shelves, userId }) {
    const renderShelves = useMemo(() => (
        shelves.map((shelf) => (
            <Shelf 
                key={shelf.id} 
                shelf={shelf} 
                userId={userId}
                navigation={navigation} />
        ))
    ), [shelves]);
    return <View>{ renderShelves }</View>
}

function Shelf({ shelf, navigation, userId }) {
    const books = useShelfBooks(shelf.sort, shelf.bookIds);
    const navigateToShelf = useCallback(() => navigation.push('Shelf', { shelfId: shelf.id }), [])
    return (
        <View key={shelf.id} style={{ marginTop: 10 }}>
            <BookListHorHeader
                tBase={tBase} 
                title={shelf.name} 
                count={shelf.bookIds.length} 
                onHeaderPress={navigateToShelf} />
            <BookListHor 
                books={books}
                context='user'
                contextId={userId}
                onSeeAllPress={navigateToShelf} 
                navigation={navigation} />
        </View>
    )
}